let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jcAPP")).then(() => parcelRequire('lq4cq'));